import ActionButton from 'components/ActionButton';
import BackButton from 'components/BackButton';
import ImageUploadComponent from 'components/ImageUploadComponent';
import { Loading } from 'components/loading/Loading';
import RenderInfo from 'components/RenderInfo';
import ToggleSwitch from 'components/ToggleSwitch';
import React, { useEffect, useState } from 'react';
import { fetchAvailableTagDetails, updateTag, updateTagImage } from 'services/api/tags';
import { showError } from 'utils';
import styles from './index.module.scss';
import TagInventoryItems from './TagInventoryItems';

const AvailableTagDetails = (props) => {
  const { match: { params: { tagId } } } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [editable, setEditable] = useState<boolean>(false);
  const [isPublic, setIsPublic] = useState<boolean>(false);
  const [tagDetails, setTagDetails] = useState<Record<string, any>>({});
  const [viewImageModalOpen, setViewImageModalOpen] = useState<boolean>(false);

  const fetchAvailableTagDetailsFn = async () => {
    try {
      const response = await fetchAvailableTagDetails(tagId);
      setTagDetails(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const updateAvailableTag = async () => {
    setLoading(true);
    try {
      await updateTag({ id: tagId, ...tagDetails, isPublic });
      fetchAvailableTagDetailsFn();
      setEditable(false);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableTagDetailsFn();
  }, []);

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Available Tag Details</div>
      <div className={styles['header-buttons']}>
        <BackButton />
        <div className='d-flex'>
          {editable ?
            <ActionButton
              text={'Save'}
              active={true}
              isLoading={false}
              onClick={updateAvailableTag}
            />
            : null}
          <ActionButton
            text={editable ? 'Cancel' : 'Edit'}
            active={true}
            isLoading={false}
            customClass={'ml-2'}
            onClick={() => setEditable(!editable)}
          />
        </div>
      </div>
    </div>
  );

  const getStripeProductImage = (imageUrl) => {
    return <img src={imageUrl} className={styles['stripe-product-image']} />;
  };

  const getTagDetails = () => (
    <>
      <div className={styles['details-section']}>
        {!editable ?
          getStripeProductImage(tagDetails?.icon?.url())
          :
          <div className={styles['image-container']}>
            <ImageUploadComponent
              entityId={tagId}
              toggleModal={() => setViewImageModalOpen(!viewImageModalOpen)}
              src={tagDetails?.icon?.url() || ''}
              uploadAPI={updateTagImage}
            />
          </div>
        }
        <div className={styles['info-container']}>
          <RenderInfo heading="ID" value={tagDetails?.objectId} />
          {editable ?
            <>
              <div className={styles['label']}>Tag Name</div>
              <input
                type={'text'}
                className={'form-control mb-2'}
                value={tagDetails?.value}
                onChange={(e) => setTagDetails({ ...tagDetails, value: e.target.value })}
              />
            </>
            :
            <RenderInfo heading="Name" value={tagDetails?.value} />
          }
          {editable ?
            <>
              <div className={styles['label']}>Tag English Name</div>
              <input
                type={'text'}
                className={'form-control mb-2'}
                value={tagDetails?.enValue}
                onChange={(e) => setTagDetails({ ...tagDetails, enValue: e.target.value })}
              />
            </>
            :
            <RenderInfo heading="English Name" value={tagDetails?.enValue} />
          }
          <RenderInfo heading="Slug" value={tagDetails?.slug} />
          <RenderInfo heading="English Slug" value={tagDetails?.enSlug} />
          {editable ?
            <>
              <div className={styles['label']}>Public</div>
              <ToggleSwitch
                switchLabel=''
                checked={isPublic}
                onChange={() => setIsPublic(!isPublic)}
              />
            </>
            :
            <RenderInfo heading="Public" value={tagDetails?.isPublic} type='boolean' />
          }
        </div>
      </div>
    </>
  );

  if (loading) return <Loading />;

  return (
    <>
      {getHeader()}
      {getTagDetails()}
      <TagInventoryItems tagDetails={tagDetails} />
    </>
  );
};

export default AvailableTagDetails;